import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegistrationModel } from '../models/registration.model';
import { RegistrationRepository } from '../repositories/registration.repository';

@Injectable({ providedIn: 'root' })
export class RegistrationService {
  private readonly repo = inject(RegistrationRepository);

  public createRegistration(registration: RegistrationModel): Observable<RegistrationModel> {
    return this.repo.sendRegistration(registration);
  }
}
